import {
    createStore,
    compose,
    applyMiddleware,
} from 'redux';

import reducers from '../reducer/reducer';

import ColorSelectionsMiddleware from '../middleware/middlewareColorSelection';
import SizesSelectionsMiddleware from '../middleware/middlewareSizeSelection';
import CustomisationMiddleware from '../middleware/middlewareCustomisation';
import reviewMiddleware from '../middleware/middlewareReview';
import alertsMiddleware from '../middleware/middlewareAlerts';

const enhancer =
    typeof window === 'object' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({}) : compose;

const initialState = {
    sizes: [],
    settings: {
        currency: '',
        locale: window.config.language_code,
        vat: '',
    },
    customizations: [],
    costumizationToggleItems: {
      unisport: false,
      products: [],
      shouldVerifyAge: false,
    },
    customizationItems: [],
    choices: [],
    selection: [],
    colorCanContinue: false,
    total: {
      total: 0,
      discount: 0,
    },
    sizeSelection: [],
    sizeCanContinue: false,
    alerts: 'none',
    alertShown: {
        isOpen: false,
        type: 'color',
    },
    alertForStep: 'one',
    ageConfirmed: false,
    helpShown: false,
};

const store = createStore(
    reducers,
    initialState,
    compose(
       enhancer(applyMiddleware(
        ColorSelectionsMiddleware,
        SizesSelectionsMiddleware,
        CustomisationMiddleware,
        reviewMiddleware,
        alertsMiddleware,
       )),
   ),
);

export default store;
